export const handleDurationString = (string) => {
	if (string && typeof string === 'string') {
		let hours = parseInt(string.slice(0, 2));
		let mins = parseInt(string.slice(3));
		return `${hours} hr ${mins} min`;
	}
};
